/* import __COLOCATED_TEMPLATE__ from './x-axis-simple-label.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();